import React from 'react'
import {
  MediaLibraryActions,
  MediaLibraryActionType,
} from '../../../providers/MLProvider'

interface ContextMenuProps {
  onContextMenu(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void
}

interface Props {
  onTrigger?(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void
  children({ onContextMenu }: ContextMenuProps): React.ReactElement
  dispatch: React.Dispatch<MediaLibraryActionType | MediaLibraryActionType[]>
}

const ContextMenuTrigger = ({
  onTrigger,
  children,
  dispatch,
}: Props): React.ReactElement => {
  return (
    <>
      {children({
        onContextMenu: event => {
          event.preventDefault()

          onTrigger?.(event)

          dispatch({
            type: MediaLibraryActions.OPEN_CONTEXT_MENU,
            payload: { x: event.pageX, y: event.pageY },
          })
        },
      })}
    </>
  )
}

export default ContextMenuTrigger
